import React from 'react';
import shallowEqual from 'react/lib/shallowEqual';

class PureComponent extends React.Component {

	shouldComponentUpdate(nextProps, nextState) {
		return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
	}

}

export default PureComponent;



// WEBPACK FOOTER //
// ./src/components/PureComponent/PureComponent.js